import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import generalController from '../../../controllers/generalController'
import { stripHTML, convertCurrency } from '../../../utils/helpers';
import Image from '../../1_Atoms/Image/Image';
import FindADealer from '../../3_Organisms/FindADealer/FindADealer'
import ReactHtmlParser from 'react-html-parser';

function FindDealerStep({
  handleNextStep,
  vehicleData,
  isTopSectionHidden,
  isEmbeddedOnBnP,
  title,
  subTitle,
  onlyEVDealers,
  preDefinedUserLocation,
  preDefinedDealerData,
  dealerId,
  currentStep,
  startingAt,
  displayPrice = true,
  isPreorderModal
}) {
	const language = generalController.detectLanguage();

  // TRUE if the selected vehicle is an EV vehicle OR onlyEVDealers is true.
  const isEvOnly = (onlyEVDealers ? onlyEVDealers : (
    vehicleData && vehicleData.isEV ? vehicleData.isEV : false
  ));

  // Generate an image path for jelly.
  const generateImageSrc = (vehicleData) => {
    if (!vehicleData || !vehicleData.visual) return '';
    const { static_content_base_path, jelly_path, jelly } = vehicleData.visual;
    return static_content_base_path + jelly_path + jelly;
  }

  const { title: vehicleTitle, description, msrp } = vehicleData || {};
  
  React.useEffect(() => {
    console.log('refreshing with dealerId', dealerId);
  }, [dealerId, preDefinedDealerData]);

  return (
    <div className="mz-find-dealer-step">
      {
        !isTopSectionHidden && (
          <div className="mz-find-dealer-step__top">
            <div className="mz-container">
              <div className="mz-full-width">
                <h4 className="mz-find-dealer-step__title">{title}</h4>
                {
                  vehicleData &&(
                    <div className="mz-find-dealer-step__vehicle">
                      {!isPreorderModal && 
                        <Image
                          src={generateImageSrc(vehicleData)}
                          alt={vehicleTitle}
                          isLazy={false}
                        />
                      }
                      <div className="mz-find-dealer-step__vehicle-bottom">
                        <h5>{ReactHtmlParser(vehicleTitle)}</h5>
                        {displayPrice ? 
                        <p className="m-0">
                           {description ? stripHTML(description) : ''}  {startingAt} {msrp ? convertCurrency(msrp, language) : ''}</p> : null}
                      </div>
                    </div>
                  )
                }
                <h5 className="mz-find-dealer-step__sub-title">{subTitle}</h5>
              </div>
            </div>
          </div>
        )
      }
      <FindADealer
        isStepRenderType={true}
        onSelectDealer={(data) => handleNextStep({ dealerData: data })}
        isEVonly={isEvOnly}
        isEmbeddedOnBnP={isEmbeddedOnBnP}
        preDefinedUserLocation={preDefinedUserLocation}
        preDefinedDealerId={preDefinedDealerData?.dealer_code}
        dealerId={dealerId}
        language={language}
		    startingAt={startingAt}
        isModelPreOrder={vehicleData?.isModelPreOrder}
      />
    </div >
  )
}

FindDealerStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  vehicleData: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  isTopSectionHidden: PropTypes.bool,
  isEmbeddedOnBnP: PropTypes.bool,
  onlyEVDealers: PropTypes.bool,
  preDefinedUserLocation: PropTypes.object,
  preDefinedDealerData: PropTypes.object,
  language: PropTypes.string,
}

FindDealerStep.defaultProps = {
  title: '',
  subTitle: '',
  isTopSectionHidden: false,
  isEmbeddedOnBnP: false,
  onlyEVDealers: false,
}

export default FindDealerStep